import { atom } from 'recoil';

type LineProfile = {
  userId: string;
  displayName: string;
  pictureUrl?: string;
}

export const lineProfileState = atom<LineProfile | null>({
  key: 'lineProfileState',
  default: null,
});


